
export abstract class TelemetryBaggageService {
  abstract get(): object
}
